import template from './component.tpl.html';
import AlTemplateGuestlistsController from './controller';

angular
    .module('festzelt-os.modules.templates')
    .component('alTemplateGuestlists', {
        bindings: {
            template: '<'
        },
        controller: AlTemplateGuestlistsController,
        controllerAs: 'vm',
        templateUrl: template
    });



// WEBPACK FOOTER //
// ./src/app/modules/templates/components/al-template-guestlists/component.js